import Alpine from "alpinejs";

Alpine.store("cart", {
    items: [],
    totalNet: 0,
    totalTax: 0,
    taxRates: null,
    totalGross: 0,
    shipping: 0,
    total: 0,
    isLoading: true,

    init() {
        this.loadCart();
    },

    async loadCart() {
        try {
            // route.api.shop.cart
            const url = this.getUrl("");
            const response = await fetch(url);

            if(!response.ok){
                throw new Error("Unable to fetch cart.");
            }

            const json = await response.json();
            if(!json.success){
                throw new Error("Unable to fetch cart.");
            }

            this.updateOrderDataFromResponse(json.data.order);

            this.isLoading = false;
        } catch (e) {
        }
    },

    async addItem(item) {
        if (this.isLoading) {
            return false;
        }

        this.isLoading = true;

        try {
            // route.api.shop.cart.add
            const url = this.getUrl(`/add`);
            const response = await fetch(url, {
                method: "POST",
                body: JSON.stringify(item),
            });
            const json = await response.json();

            if (json.success) {
                console.log(json.data.order);
                this.updateOrderDataFromResponse(json.data.order);
                return true;
            }
        } catch (error) {
            return false;
        } finally {
            this.isLoading = false;
        }

        return false;
    },

    async removeItem(item) {
        if (this.isLoading) {
            return;
        }

        this.isLoading = true;

        try {
            // route.api.shop.cart.item.remove
            const url = this.getUrl(`/${item.id}`);
            const response = await fetch(url, { method: "DELETE" });
            const json = await response.json();

            if (json.success) {
                this.updateOrderDataFromResponse(json.data.order);
            }
        } catch (e) {
            alert("Unable to update cart, try again later.");
        } finally {
            this.isLoading = false;
        }
    },

    async updateItemAmount(item) {
        if (this.isLoading) {
            return;
        }

        this.isLoading = true;

        try {
            // route.api.shop.cart.item.amount
            const url = this.getUrl(`/${item.id}/amount`);
            const response = await fetch(url, {
                method: "POST",
                body: JSON.stringify({
                    amount: item.amount,
                }),
            });
            const json = await response.json();

            if (json.success) {
                this.updateOrderDataFromResponse(json.data.order);
            }
        } catch (e) {
            alert("Unable to update cart, try again later.");
        } finally {
            this.isLoading = false;
        }
    },

    getUrl(url) {
        let fullUrl = `/api/kht/webshop/${document.documentElement.lang}/cart` + url;
        if (Alpine.store("auth").isGuest) {
            fullUrl += `?guestToken=${encodeURIComponent(Alpine.store("auth").guestToken)}`;
        }

        return fullUrl;
    },

    updateOrderDataFromResponse(order) {
        this.items = order.items;
        this.totalNet = order.totalNet;
        this.totalTax = order.totalTax;
        this.taxRates = order.taxRates ?? null;
        this.totalGross = order.totalGross;
        this.shipping = order.shipping;
        this.total = order.total;
    },
});
